import { analytics, EEVENT_LABEL } from 'affiny-core/analytics';
import { promisifyDispatch } from 'affiny-core/modules/helpers';
import { postPicturesAction } from 'affiny-core/modules/pictures/actions';
import { Dispatch } from 'redux';
import { IPicture } from '../../modules/pictures/types';

export enum EBUTTON_ACTION_ICONS {
  DELETE = 'Cross',
  MORE = 'Submenu',
}

export function getPictureStatus(picture: IPicture) {
  if (picture.attributes.isOnModeration) {
    return 'profilePictureEditGallery.pendingValidation';
  }

  if (picture.attributes.isMainPicture) {
    return 'profilePictureEditGallery.profilePicture';
  }

  return '';
}

export function getPictureActionType({
  canEditPicture,
  isMainPicture,
}: {
  canEditPicture: boolean;
  isMainPicture?: boolean;
}) {
  if (!canEditPicture) return undefined;

  if (isMainPicture) return EBUTTON_ACTION_ICONS.DELETE;

  return EBUTTON_ACTION_ICONS.MORE;
}

export const convertToBase64 = (file: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (!reader.result) return reject();

      const base64 = reader.result as string;

      resolve(base64.substring(base64.indexOf(',') + 1));
    };
    reader.readAsDataURL(file);
  });

export interface IImage extends HTMLImageElement {
  type: string;
}

export const handleUploadPhoto = (dispatch: Dispatch, file?: Blob) => {
  if (!file) return;

  analytics.trackEvent(EEVENT_LABEL.ADD_PHOTO_CLICK_CTA_VALIDATE);

  convertToBase64(file).then(base64 => {
    promisifyDispatch(
      dispatch,
      postPicturesAction
    )({
      imageBase64: base64,
      type: 'portrait',
      refreshPictures: false,
    });
  });
};

export const inputFileBase64toApiBase64 = (fileUploadBase64: string): string =>
  fileUploadBase64.substring(fileUploadBase64.indexOf(',') + 1);
